import {
    ChonkyActions,
    FileBrowser,
    FileContextMenu,
    FileHelper,
    FileList,
    FileNavbar,
    FileToolbar,
    setChonkyDefaults,
} from 'chonky';
import {ChonkyIconFA} from 'chonky-icon-fontawesome';
import React, {useCallback, useMemo, useState} from 'react';
import Env from "../config/env";

setChonkyDefaults({iconComponent: ChonkyIconFA});

export const useFiles = (currentFolderId, fileMap) => {
    return useMemo(() => {
        const currentFolder = fileMap[currentFolderId];
        const files = currentFolder.childrenIds
            ? currentFolder.childrenIds.map((fileId) => fileMap[fileId] ?? null)
            : [];
        return files;
    }, [currentFolderId, fileMap]);
};

export const useFolderChain = (currentFolderId, fileMap) => {
    return useMemo(() => {
        const currentFolder = fileMap[currentFolderId];

        const folderChain = [currentFolder];

        let parentId = currentFolder.parentId;
        while (parentId) {
            const parentFile = fileMap[parentId];
            if (parentFile) {
                folderChain.unshift(parentFile);
                parentId = parentFile.parentId;
            } else {
                parentId = null;
            }
        }

        return folderChain;
    }, [currentFolderId, fileMap]);
};

export const useFileActionHandler = (
    setCurrentFolderId
) => {
    return useCallback(
        (data) => {
            if (data.id === ChonkyActions.OpenFiles.id) {
                const {targetFile, files} = data.payload;
                const fileToOpen = targetFile ?? files[0];
                if (fileToOpen && FileHelper.isDirectory(fileToOpen)) {
                    setCurrentFolderId(fileToOpen.id);
                    return;
                }
                if (fileToOpen) {
                    window.open(`${Env.UrlBackendEHGC}/getFile/${fileToOpen.path}`)
                }
            }
        },
        [setCurrentFolderId]
    );
};

export const MyFileBrowser = (props) => {

    const rootFolderId = props.dataFiles.rootFolderId;
    const fileMap = props.dataFiles.fileMap;
    const [currentFolderId, setCurrentFolderId] = useState(rootFolderId);
    const files = useFiles(currentFolderId, fileMap);
    const folderChain = useFolderChain(currentFolderId, fileMap);
    const handleFileAction = useFileActionHandler(setCurrentFolderId);
    return (
        <div style={{height: 400}}>
            <FileBrowser
                files={files}
                folderChain={folderChain}
                onFileAction={handleFileAction}
                thumbnailGenerator={(file) =>
                    file.thumbnailUrl ? `https://chonky.io${file.thumbnailUrl}` : null
                }
            >
                <FileNavbar/>
                <FileToolbar/>
                <FileList/>
                <FileContextMenu/>
            </FileBrowser>
        </div>
    );
};

